export default /iPad|iPhone|iPod|Mac/.test(navigator.userAgent);
